import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from 'components/core/Button';

import './ModalCloseText.scss';

export default function ModalCloseText({ onClick, className, text = 'Close', ...rest }) {
	return (
		<Button
			onClick={onClick}
			className={classnames('new-modal-close-button', 'close-text', className)}
			primary={false}
			{...rest}
		>
			{text}
		</Button>
	);
}

ModalCloseText.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func,
	text: PropTypes.string
};
